/**
 * Date format options for report columns.
 */
export const DATE_FORMAT_OPTIONS = [
  { value: "yyyy-mm-dd", label: "YYYY-MM-DD" },
  { value: "dd-mm-yyyy", label: "DD-MM-YYYY" },
  { value: "yyyy/mm/dd", label: "YYYY/MM/DD" },
  { value: "dd/mm/yyyy", label: "DD/MM/YYYY" },
  { value: "yyyy-mm-dd HH:mm", label: "YYYY-MM-DD HH:mm" },
  { value: "yyyy-mm-dd HH:mm:ss", label: "YYYY-MM-DD HH:mm:ss" },
  { value: "custom", label: "Custom Format..." }
];

/**
 * Number format options for report columns.
 */
export const NUMBER_FORMAT_OPTIONS = [
  { value: "none", label: "No Formatting" },
  { value: "0.0", label: "1 Decimal Place (0.0)" },
  { value: "0.00", label: "2 Decimal Places (0.00)" },
  { value: "0.000", label: "3 Decimal Places (0.000)" },
  { value: "custom", label: "Custom Format..." }
];

/**
 * Format validation patterns for date and number formats.
 */
export const FORMAT_PATTERNS = {
  date: {
    pattern: /^[yYmdHhMmsSAaZz\s\-/.:]+$/,
    message: "Invalid date format."
  },
  number: {
    pattern: /^0\.\d+$/,
    message: "Invalid number format."
  }
};

/**
 * Example values for each format type.
 */
export const FORMAT_EXAMPLES = {
  date: {
    "yyyy-mm-dd": "2024-03-20",
    "dd-mm-yyyy": "20-03-2024",
    "yyyy/mm/dd": "2024/03/20",
    "dd/mm/yyyy": "20/03/2024",
    "yyyy-mm-dd HH:mm": "2024-03-20 14:30",
    "yyyy-mm-dd HH:mm:ss": "2024-03-20 14:30:45"
  },
  number: {
    "none": "1234.5678",
    "integer": "1235",
    "decimal_1": "1234.6",
    "decimal_2": "1234.57",
    "decimal_3": "1234.568",
  }
};

/**
 * Default formats for each column type.
 */
export const DEFAULT_FORMATS = {
  date: "yyyy-mm-dd",
  number: "none",
  string: "none"
};

/**
 * Column type options for template columns.
 */
export const COLUMN_TYPE_OPTIONS = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "datetime", label: "DateTime" },
  { value: "boolean", label: "Boolean" },
];

/**
 * Filter type options for template filters.
 */
export const FILTER_TYPE_OPTIONS = [
  { value: "daterange", label: "Date Range" },
  { value: "periodfilter", label: "Period Filter" },
  { value: "monthyear", label: "Month Year" },
  { value: "daterangeAndPeriod", label: "Date Range & Period" },
  { value: null, label: "No Filter" }
];

/**
 * UI color constants for consistent styling.
 */
export const UI_CONSTANTS = {
  PRIMARY_COLOR: "#24c6b1",
  ERROR_COLOR: "#ef4444",
  SUCCESS_COLOR: "#10b981",
  WARNING_COLOR: "#f59e0b"
};

/**
 * Placeholder text for various input fields.
 */
export const PLACEHOLDERS = {
  REPORT_NAME: "Enter report name",
  CUSTOM_DATE_FORMAT: "Enter custom date format (e.g., yyyy-mm-dd)",
  CUSTOM_NUMBER_FORMAT: "Enter custom number format (e.g., #,##0.00)",
  TEMPLATE_NAME: "Enter template name",
  TEMPLATE_QUERY: "Enter SQL query",
  COLUMN_KEY: "e.g., order_id",
  COLUMN_LABEL: "e.g., Order ID",
  FILTER_ID: "e.g., date_range",
  FILTER_LABEL: "e.g., Date Range",
  GLOBAL_FILTER_ID: "e.g., region",
  GLOBAL_FILTER_LABEL: "e.g., Region",
  GLOBAL_FILTER_API: "e.g., /api/locations"
};

/**
 * Error messages for user feedback and validation.
 */
export const ERROR_MESSAGES = {
  NO_TEMPLATE_SELECTED: "Please select a template first",
  DUPLICATE_HEADERS: "Duplicate header names are not allowed",
  INVALID_FORMAT: "Invalid format specified",
  REQUIRED_FIELD: "This field is required",
  UPDATE_TEMPLATE: "Failed to update template",
  CREATE_TEMPLATE: "Failed to create template"
};

/**
 * Success messages for user feedback.
 */
export const SUCCESS_MESSAGES = {
  TEMPLATE_UPDATED: "Template updated successfully",
  TEMPLATE_CREATED: "Template created successfully"
}; 